import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AuthenticationRoutingModule} from "src/app/applications/authentication/authentication-routing.module";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AuthenticationRoutingModule,
  ],
  providers:[]
})
export class AuthenticationModule { }
